export { default } from './src/ActivitiesLike';
export { default as FirstLikeModal } from './src/blocks/FirstLikeModal';
export { default as LikesMergeObserver } from './src/blocks/LikesMergeObserver';

export type { ActivitiesLikeProps } from './src/ActivitiesLike';
export type { FirstLikeModalProps } from './src/blocks/FirstLikeModal';
